import type { Theme } from '@material-ui/core';

// Least height of the band above the table and of the header, so the header
// is never lower than the band
const BAANDHOYDE = 48;

/**
 * Shared look for the tables in the list views. Targets elements, since MUI's
 * class names get a generated suffix in this app.
 */
export const listetabellStiler = (theme: Theme) => ({
    // The band with the number of rows and «Vis kolonner» above the table. The
    // title lines up with the text in the first column.
    '& [role="toolbar"]': {
        minHeight: BAANDHOYDE,
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 16,
    },
    '& [role="toolbar"] button': {
        padding: 6,
    },
    // Lower header. The labels can still wrap to more lines. The height of a
    // table cell works as a least height.
    '& thead th': {
        height: BAANDHOYDE,
        paddingTop: 4,
        paddingBottom: 4,
    },
    '& thead th button': {
        lineHeight: 1.25,
    },
    // The header cells are sticky and each get their own layer, so at
    // fractional widths a light seam can show between two of them. The same
    // colour on the row behind hides it.
    '& thead tr': {
        backgroundColor: theme.palette.secondary.veryLight,
    },
    // Lower rows. The text can still wrap to more lines.
    '& tbody td': {
        paddingTop: 8,
        paddingBottom: 8,
    },
    // The menu button would otherwise set the height of rows with one line
    '& tbody td button': {
        padding: 6,
    },
});
